var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFolder(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.25 14.625V4.5C2.25 4.35082 2.30926 4.20774 2.41475 4.10225C2.52024 3.99676 2.66332 3.9375 2.8125 3.9375H6.5625C6.68421 3.9375 6.80263 3.97697 6.9 4.05L8.85 5.5125C8.94737 5.58553 9.06579 5.625 9.1875 5.625H14.0625C14.2117 5.625 14.3548 5.68426 14.4602 5.78975C14.5657 5.89524 14.625 6.03832 14.625 6.1875V7.875",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.25 14.625L4.35856 9.35359C4.40031 9.24921 4.47239 9.15974 4.56548 9.09671C4.65857 9.03369 4.76841 9 4.88083 9H8.26719C8.37824 9 8.48681 8.96713 8.57921 8.90553L9.98329 7.96947C10.0757 7.90787 10.1843 7.875 10.2953 7.875H16.0946C16.1837 7.875 16.2716 7.89618 16.3509 7.93679C16.4302 7.97741 16.4988 8.0363 16.5509 8.1086C16.603 8.18091 16.6372 8.26456 16.6506 8.35267C16.6641 8.44078 16.6564 8.53082 16.6282 8.61538L14.625 14.625H2.25Z",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFolder);
export default __webpack_public_path__ + "static/media/folder.c73e8114f85cc174f5f99b291d6c0fc3.svg";
export { ForwardRef as ReactComponent };